module.exports = __webpack_public_path__ + "static/assets/f368eb36724d400b79a10cd5abf90697.png";